export interface PrivacyPolicy {
  id?: number;
  descricao: string;
  mensagem: string;
  status: number;
  data_criacao?: string;
  data_publicacao?: string;
  lido?: boolean;
}

export interface PrivacyPolicyView extends PrivacyPolicy {
  formattedStatus: string;
  formattedCriacao: string;
  formattedPublicacao: string;
  statusColor: string;
  formattedMensage: string;
  formattedMessageTooltip: string;
}

export interface PrivacyPolicyFile {
  id: number | string;
  file: File;
  nome_arquivo: string;
  tamanho_arquivo: number | string;
}
// eslint-disable-next-line no-shadow
export enum PrivacyPolicyStatus {
  RASCUNHO = 0,
  PUBLICADO = 1,
  CANCELADO = 2,
}

// eslint-disable-next-line no-shadow
export enum PrivacyPolicyStatusClient {
  NAO_LIDO = 0,
  LIDO = 1,
}
